<form
  [formGroup]="form"
  (ngSubmit)="confirm()"
  class="flex flex-col">
  <div class="flex flex-col">
    <div class="flex w-full justify-between gap-4 py-4 border-b border-neutral-300">
      <span class="text-[18px] font-black">
        <i
          class="pi pi-file-edit"
          style="font-size: 2rem"></i>
        SUBSANACION DE DESPLIEGUE DE SISTEMA
      </span>
      <div class="flex gap-4">
        <app-buttons
          [label]="'Detalle de subsanación'"
          (click)="goToSummary()" />
        <app-buttons
          [label]="'Volver al paso anterior'"
          (click)="backPage()" />
        <app-buttons
          [label]="'Continuar'"
          [disabled]="form.invalid || hasPendingObservedFieldsInStep()"
          [classes]="'bg-primary-base text-primary-light'"
          (click)="confirm()"
          type="button" />
      </div>
    </div>

    <div class="flex flex-col py-4">
      <span class="font-regular text-[18px]">Paso 5 de 6</span>
      <h2 class="font-bold text-[24px] pb-6">Cuestiones técnicas</h2>

      <h3 class="font-bold text-[18px] pb-6">Datos de entrenamiento</h3>

      <div class="grid grid-cols-2">
        <div class="mr-6 flex flex-col relative">
          <app-observed-field-alert
            *ngIf="isObserved('aiSystemUpdate')"
            class="absolute top-2 left-0"></app-observed-field-alert>
          <desy-select
            formControlName="aiSystemUpdate"
            classes="min-w-full">
            <desy-label [ngClass]="{ 'relative -top-4': isObserved('aiSystemUpdate') }">
              Frecuencia y política de actualización*
            </desy-label>
            <desy-option
              [disabled]="true"
              [selected]="true"
              [hidden]="true">
              Selecciona si hay política de actualización
            </desy-option>
            <desy-option
              *ngFor="let item of binaryOptions"
              [id]="item.label"
              [value]="item.value">
              {{ item.label }}
            </desy-option>
          </desy-select>
          <desy-error-message *ngIf="getError(form, 'aiSystemUpdate', formSubmitted()) as error">
            {{ error }}
          </desy-error-message>
        </div>
      </div>

      <ng-container *ngIf="aiSystemUpdateRequired()">
        <div class="flex flex-col -mt-2 relative">
          <desy-label [ngClass]="{ 'relative -top-4': isObserved('aiSystemUpdateDescription') }">
            Descripción*
          </desy-label>
          <app-observed-field-alert
            *ngIf="isObserved('aiSystemUpdateDescription')"
            class="absolute top-2 left-0"></app-observed-field-alert>
          <desy-textarea
            id="aiSystemUpdateDescription"
            [classes]="'w-full'"
            [placeholder]="'Describe aquí la política de actualización del sistema de IA'"
            formControlName="aiSystemUpdateDescription"
            [rows]="3"
            [maxlength]="500"></desy-textarea>
          <ng-container
            *ngIf="
              getError(form, 'aiSystemUpdateDescription', formSubmitted()) as error;
              else aiSystemUpdateDescriptionInfo
            ">
            <desy-error-message>
              {{ error }}
            </desy-error-message>
          </ng-container>
          <ng-template #aiSystemUpdateDescriptionInfo>
            <span class="text-[14px] text-neutral-dark info-message block">Puedes escribir hasta 500 caracteres</span>
          </ng-template>
        </div>
      </ng-container>

      <h3 class="font-bold text-[18px] pb-6 mt-6">Operación</h3>

      <div class="grid grid-cols-2">
        <div class="mr-6 flex flex-col relative">
          <app-observed-field-alert
            *ngIf="isObserved('latencyPerformance')"
            class="absolute top-2 left-0"></app-observed-field-alert>
          <desy-select
            formControlName="latencyPerformance"
            classes="min-w-full">
            <desy-label [ngClass]="{ 'relative -top-4': isObserved('latencyPerformance') }">
              Latencia y rendimiento verificados*
            </desy-label>
            <desy-option
              [disabled]="true"
              [selected]="true"
              [hidden]="true">
              Selecciona si hay latencia y rendimiento verificados
            </desy-option>
            <desy-option
              *ngFor="let item of binaryOptions"
              [id]="item.label"
              [value]="item.value">
              {{ item.label }}
            </desy-option>
          </desy-select>
          <desy-error-message *ngIf="getError(form, 'latencyPerformance', formSubmitted()) as error">
            {{ error }}
          </desy-error-message>
        </div>
      </div>

      <ng-container *ngIf="latencyPerformanceRequired()">
        <div class="flex flex-col -mt-2 mb-4 relative">
          <desy-label [ngClass]="{ 'relative -top-4': isObserved('latencyPerformanceDescription') }">
            Descripción*
          </desy-label>
          <app-observed-field-alert
            *ngIf="isObserved('latencyPerformanceDescription')"
            class="absolute top-2 left-0"></app-observed-field-alert>
          <desy-textarea
            id="latencyPerformanceDescription"
            [classes]="'w-full'"
            [placeholder]="'Describe aquí la latencia y el rendimiento verificados del sistema de IA'"
            formControlName="latencyPerformanceDescription"
            [rows]="3"
            [maxlength]="500"></desy-textarea>
          <ng-container
            *ngIf="
              getError(form, 'latencyPerformanceDescription', formSubmitted()) as error;
              else latencyPerformanceDescriptionInfo
            ">
            <desy-error-message>
              {{ error }}
            </desy-error-message>
          </ng-container>
          <ng-template #latencyPerformanceDescriptionInfo>
            <span class="text-[14px] text-neutral-dark info-message block">Puedes escribir hasta 500 caracteres</span>
          </ng-template>
        </div>
      </ng-container>

      <div class="grid grid-cols-2 items-end">
        <div class="mr-6 flex flex-col relative">
          <app-observed-field-alert
            *ngIf="isObserved('scalability')"
            class="absolute top-2 left-0"></app-observed-field-alert>
          <desy-select
            formControlName="scalability"
            classes="min-w-full">
            <desy-label [ngClass]="{ 'relative -top-4': isObserved('scalability') }">
              Escalabilidad documentada*
            </desy-label>
            <desy-option
              [disabled]="true"
              [selected]="true"
              [hidden]="true">
              Selecciona si hay escalabilidad documentada
            </desy-option>
            <desy-option
              *ngFor="let item of binaryOptions"
              [id]="item.label"
              [value]="item.value">
              {{ item.label }}
            </desy-option>
          </desy-select>
          <desy-error-message *ngIf="getError(form, 'scalability', formSubmitted()) as error">
            {{ error }}
          </desy-error-message>
        </div>

        <div class="flex flex-col relative">
          <ng-container *ngIf="scalabilityRequired()">
            <label
              class="text-[14px] text-neutral-dark block"
              [ngClass]="{ 'relative -top-4': isObserved('scalabilityCsv') }">
              CSV*
            </label>
            <app-observed-field-alert
              *ngIf="isObserved('scalabilityCsv')"
              class="absolute top-2 left-0"></app-observed-field-alert>
            <desy-input
              id="scalabilityCsv"
              [classes]="'w-full'"
              [placeholder]="'Objeto 1, Objeto 2...'"
              formControlName="scalabilityCsv"></desy-input>
            <desy-error-message *ngIf="getError(form, 'scalabilityCsv', formSubmitted()) as error">
              {{ error }}
            </desy-error-message>
          </ng-container>
        </div>
      </div>

      <div class="grid grid-cols-2 items-end">
        <div class="mr-6 flex flex-col relative">
          <app-observed-field-alert
            *ngIf="isObserved('contingencyPlan')"
            class="absolute top-2 left-0"></app-observed-field-alert>
          <desy-select
            formControlName="contingencyPlan"
            classes="min-w-full">
            <desy-label [ngClass]="{ 'relative -top-4': isObserved('contingencyPlan') }">
              Plan de contingencia y desactivación*
            </desy-label>
            <desy-option
              [disabled]="true"
              [selected]="true"
              [hidden]="true">
              Selecciona si hay plan de contingencia
            </desy-option>
            <desy-option
              *ngFor="let item of binaryOptions"
              [id]="item.label"
              [value]="item.value">
              {{ item.label }}
            </desy-option>
          </desy-select>
          <desy-error-message *ngIf="getError(form, 'contingencyPlan', formSubmitted()) as error">
            {{ error }}
          </desy-error-message>
        </div>

        <div class="flex flex-col relative">
          <ng-container *ngIf="contingencyPlanRequired()">
            <label
              class="text-[14px] text-neutral-dark block"
              [ngClass]="{ 'relative -top-4': isObserved('contingencyPlanCsv') }">
              CSV*
            </label>
            <app-observed-field-alert
              *ngIf="isObserved('contingencyPlanCsv')"
              class="absolute top-2 left-0"></app-observed-field-alert>
            <desy-input
              id="contingencyPlanCsv"
              [classes]="'w-full'"
              [placeholder]="'Objeto 1, Objeto 2...'"
              formControlName="contingencyPlanCsv"></desy-input>
            <desy-error-message *ngIf="getError(form, 'contingencyPlanCsv', formSubmitted()) as error">
              {{ error }}
            </desy-error-message>
          </ng-container>
        </div>
      </div>

      <h3 class="font-bold text-[18px] pb-4 mt-6">Seguridad</h3>

      <div class="grid grid-cols-2">
        <div class="mr-6 flex flex-col relative">
          <app-observed-field-alert
            *ngIf="isObserved('cybersecurity')"
            class="absolute top-2 left-0"></app-observed-field-alert>
          <desy-select
            formControlName="cybersecurity"
            classes="min-w-full">
            <desy-label [ngClass]="{ 'relative -top-4': isObserved('cybersecurity') }">
              Ciberseguridad integrada*
            </desy-label>
            <desy-option
              [disabled]="true"
              [selected]="true"
              [hidden]="true">
              Selecciona si hay ciberseguridad integrada
            </desy-option>
            <desy-option
              *ngFor="let item of binaryOptions"
              [id]="item.label"
              [value]="item.value">
              {{ item.label }}
            </desy-option>
          </desy-select>
          <desy-error-message *ngIf="getError(form, 'cybersecurity', formSubmitted()) as error">
            {{ error }}
          </desy-error-message>
          <ng-container *ngIf="!cybersecurityExtraFilled() && cybersecurityRequired()">
            <desy-error-message class="block font-semibold">
              Rellena obligatoriamente uno de los dos campos siguientes:
            </desy-error-message>
          </ng-container>
        </div>
      </div>
      <ng-container *ngIf="cybersecurityRequired()">
        <div class="grid grid-cols-2 mt-4">
          <div class="flex flex-col relative">
            <span
              class="text-[14px] text-neutral-dark"
              [ngClass]="{ 'relative -top-2': isObserved('cybersecurityCsv') }">
              Con CSV
            </span>
            <app-observed-field-alert
              *ngIf="isObserved('cybersecurityCsv')"
              class="absolute top-2 left-0"></app-observed-field-alert>
            <desy-input
              id="cybersecurityCsv"
              [classes]="'w-full'"
              [placeholder]="'Validación 1, validación 2...'"
              formControlName="cybersecurityCsv"></desy-input>
          </div>
        </div>
        <div class="flex flex-col relative">
          <span
            class="text-[14px] text-neutral-dark block"
            [ngClass]="{ 'relative -top-2': isObserved('cybersecurityDescription') }">
            Descripción
          </span>
          <app-observed-field-alert
            *ngIf="isObserved('cybersecurityDescription')"
            class="absolute top-2 left-0"></app-observed-field-alert>
          <desy-textarea
            id="cybersecurityDescription"
            [classes]="'w-full'"
            [placeholder]="'Describe aquí la validación contra controles ISO 42001'"
            formControlName="cybersecurityDescription"
            [rows]="3"
            [maxlength]="500"></desy-textarea>
          <span class="text-[14px] text-neutral-dark info-message block">Puedes escribir hasta 500 caracteres</span>
        </div>
      </ng-container>

      <div class="grid grid-cols-2">
        <div class="mr-6 flex flex-col relative">
          <app-observed-field-alert
            *ngIf="isObserved('accessControl')"
            class="absolute top-2 left-0"></app-observed-field-alert>
          <desy-select
            formControlName="accessControl"
            classes="min-w-full">
            <desy-label [ngClass]="{ 'relative -top-4': isObserved('accessControl') }">
              Control de acceso y autenticación*
            </desy-label>
            <desy-option
              [disabled]="true"
              [selected]="true"
              [hidden]="true">
              Selecciona si hay control de acceso y autenticación
            </desy-option>
            <desy-option
              *ngFor="let item of binaryOptions"
              [id]="item.label"
              [value]="item.value">
              {{ item.label }}
            </desy-option>
          </desy-select>
          <desy-error-message *ngIf="getError(form, 'accessControl', formSubmitted()) as error">
            {{ error }}
          </desy-error-message>
        </div>
      </div>

      <ng-container *ngIf="accessControlRequired()">
        <div class="flex flex-col -mt-4 mb-4 relative">
          <desy-label [ngClass]="{ 'relative -top-4': isObserved('accessControlDescription') }">
            Descripción*
          </desy-label>
          <app-observed-field-alert
            *ngIf="isObserved('accessControlDescription')"
            class="absolute top-2 left-0"></app-observed-field-alert>
          <desy-textarea
            id="accessControlDescription"
            [classes]="'w-full'"
            [placeholder]="'Describe aquí el control de acceso y autenticación del sistema de IA'"
            formControlName="accessControlDescription"
            [rows]="3"
            [maxlength]="500"></desy-textarea>
          <ng-container
            *ngIf="
              getError(form, 'accessControlDescription', formSubmitted()) as error;
              else accessControlDescriptionInfo
            ">
            <desy-error-message>
              {{ error }}
            </desy-error-message>
          </ng-container>
          <ng-template #accessControlDescriptionInfo>
            <span class="text-[14px] text-neutral-dark info-message block">Puedes escribir hasta 500 caracteres</span>
          </ng-template>
        </div>
      </ng-container>

      <div class="grid grid-cols-2">
        <div class="mr-6 flex flex-col relative">
          <app-observed-field-alert
            *ngIf="isObserved('attackProtection')"
            class="absolute top-2 left-0"></app-observed-field-alert>
          <desy-select
            formControlName="attackProtection"
            classes="min-w-full">
            <desy-label [ngClass]="{ 'relative -top-4': isObserved('attackProtection') }">
              Protección contra ataques adversariales*
            </desy-label>
            <desy-option
              [disabled]="true"
              [selected]="true"
              [hidden]="true">
              Selecciona si hay protección contra ataques adversariales
            </desy-option>
            <desy-option
              *ngFor="let item of binaryOptions"
              [id]="item.label"
              [value]="item.value">
              {{ item.label }}
            </desy-option>
          </desy-select>
          <desy-error-message *ngIf="getError(form, 'attackProtection', formSubmitted()) as error">
            {{ error }}
          </desy-error-message>
          <ng-container *ngIf="!attackProtectionExtraFilled() && attackProtectionRequired()">
            <desy-error-message class="block font-semibold">
              Rellena obligatoriamente uno de los dos campos siguientes:
            </desy-error-message>
          </ng-container>
        </div>
      </div>
      <ng-container *ngIf="attackProtectionRequired()">
        <div class="grid grid-cols-2 mt-4">
          <div class="flex flex-col relative">
            <span
              class="text-[14px] text-neutral-dark"
              [ngClass]="{ 'relative -top-2': isObserved('attackProtectionCsv') }">
              Con CSV
            </span>
            <app-observed-field-alert
              *ngIf="isObserved('attackProtectionCsv')"
              class="absolute top-2 left-0"></app-observed-field-alert>
            <desy-input
              id="attackProtectionCsv"
              [classes]="'w-full'"
              [placeholder]="'Validación 1, validación 2...'"
              formControlName="attackProtectionCsv"></desy-input>
          </div>
        </div>
        <div class="flex flex-col relative">
          <span
            class="text-[14px] text-neutral-dark block"
            [ngClass]="{ 'relative -top-2': isObserved('attackProtectionDescription') }">
            Descripción
          </span>
          <app-observed-field-alert
            *ngIf="isObserved('attackProtectionDescription')"
            class="absolute top-2 left-0"></app-observed-field-alert>
          <desy-textarea
            id="attackProtectionDescription"
            [classes]="'w-full'"
            [placeholder]="'Describe aquí la validación contra controles ISO 42001'"
            formControlName="attackProtectionDescription"
            [rows]="3"
            [maxlength]="500"></desy-textarea>
          <span class="text-[14px] text-neutral-dark info-message block">Puedes escribir hasta 500 caracteres</span>
        </div>
      </ng-container>

      <div class="grid grid-cols-2">
        <div class="mr-6 flex flex-col relative">
          <app-observed-field-alert
            *ngIf="isObserved('resilience')"
            class="absolute top-2 left-0"></app-observed-field-alert>
          <desy-select
            formControlName="resilience"
            classes="min-w-full">
            <desy-label [ngClass]="{ 'relative -top-4': isObserved('resilience') }">
              Resiliencia frente a fallos*
            </desy-label>
            <desy-option
              [disabled]="true"
              [selected]="true"
              [hidden]="true">
              Selecciona sI hay resiliencia frente a fallos
            </desy-option>
            <desy-option
              *ngFor="let item of binaryOptions"
              [id]="item.label"
              [value]="item.value">
              {{ item.label }}
            </desy-option>
          </desy-select>
          <desy-error-message *ngIf="getError(form, 'resilience', formSubmitted()) as error">
            {{ error }}
          </desy-error-message>
          <ng-container *ngIf="!resilienceExtraFilled() && resilienceRequired()">
            <desy-error-message class="block font-semibold">
              Rellena obligatoriamente uno de los dos campos siguientes:
            </desy-error-message>
          </ng-container>
        </div>
      </div>
      <ng-container *ngIf="resilienceRequired()">
        <div class="grid grid-cols-2 mt-4">
          <div class="flex flex-col relative">
            <span
              class="text-[14px] text-neutral-dark"
              [ngClass]="{ 'relative -top-2': isObserved('resilienceCsv') }">
              Con CSV
            </span>
            <app-observed-field-alert
              *ngIf="isObserved('resilienceCsv')"
              class="absolute top-2 left-0"></app-observed-field-alert>
            <desy-input
              id="resilienceCsv"
              [classes]="'w-full'"
              [placeholder]="'Validación 1, validación 2...'"
              formControlName="resilienceCsv"></desy-input>
          </div>
        </div>
        <div class="flex flex-col relative">
          <span
            class="text-[14px] text-neutral-dark block"
            [ngClass]="{ 'relative -top-2': isObserved('resilienceDescription') }">
            Descripción
          </span>
          <app-observed-field-alert
            *ngIf="isObserved('resilienceDescription')"
            class="absolute top-2 left-0"></app-observed-field-alert>
          <desy-textarea
            id="resilienceDescription"
            [classes]="'w-full'"
            [placeholder]="'Describe aquí la validación contra controles ISO 42001'"
            formControlName="resilienceDescription"
            [rows]="3"
            [maxlength]="500"></desy-textarea>
          <span class="text-[14px] text-neutral-dark info-message block">Puedes escribir hasta 500 caracteres</span>
        </div>
      </ng-container>
    </div>
  </div>
</form>
